import React, { useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { NAV } from "../Navbar/navbarTheme";
import Transportation from "../Images/6.jpg";
import {
  bulletListSx,
  listItemSx,
  pageContentSx,
  pageGutterSx,
  pageShellSx,
  pageTitleSx,
  sectionBodySx,
  sectionHeadingSx,
} from "./whatWeOfferStyles";

const introText =
  "Take advantage of our active weekly transport routes connecting the UK with the Middle East and neighbouring regions. UK TO MARS LTD operates its own logistics network, ensuring you receive reliable and cost-effective shipping, every time.";

const featureBullets = [
  "Scheduled weekly departures from our UK warehouse",
  "Full trailer loads (FTL), groupage, and flexible load options",
  "Real-time shipment tracking and proactive communication",
  "Customs transit documentation handled by our team",
  "Door-to-door solutions with secure, on-time delivery",
];

const closingText =
  "With our established routes and dedicated transport fleet, your goods travel quickly and safely from the UK to the destination country.";

function FeatureBulletList({ items }) {
  return (
    <List dense sx={bulletListSx}>
      {items.map((item) => (
        <ListItem key={item} sx={listItemSx}>
          <ListItemText
            primary={item}
            primaryTypographyProps={{
              sx: {
                fontSize: { xs: "0.9375rem", md: "1.0625rem" },
                lineHeight: 1.7,
              },
            }}
          />
        </ListItem>
      ))}
    </List>
  );
}

const LowestPrice = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box component="main" sx={pageShellSx}>
      <Box sx={pageGutterSx}>
        <Box sx={pageContentSx}>
          <Typography component="h1" sx={pageTitleSx}>
            International Transportation
          </Typography>

          <Typography sx={{ ...sectionBodySx, maxWidth: 900, mx: { md: "auto" } }}>
            {introText}
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: { xs: 3, md: 4, lg: 5 },
              alignItems: "center",
              mt: { xs: 3, md: 4 },
              pt: { xs: 3, md: 4 },
              borderTop: `1px solid ${NAV.line}`,
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              <Typography component="h2" sx={sectionHeadingSx}>
                Key features
              </Typography>
              <FeatureBulletList items={featureBullets} />
              <Typography sx={{ ...sectionBodySx, mb: 0, mt: 2 }}>
                {closingText}
              </Typography>
            </Box>

            <Box
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                border: `1px solid ${NAV.line}`,
                boxShadow: "0 10px 32px rgba(15, 40, 71, 0.1)",
                bgcolor: "#fff",
              }}
            >
              <Box
                component="img"
                src={Transportation}
                alt="International transportation"
                sx={{
                  display: "block",
                  width: "100%",
                  height: "auto",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LowestPrice;
